<template>
  <div class="login-index">
    <div class="content">
      <div class="l-img">
      </div>
      <div class="main  p20">
        <el-tabs v-model="activeName" class="e-tabs" @tab-click="handleClick">
          <el-tab-pane label="短信登录" name="shortMessage">
            <shortMessageLogin />
          </el-tab-pane>
          <el-tab-pane label="密码登录" name="password">
            <passwordLogin />
          </el-tab-pane>
        </el-tabs>
        <div class="title">注册即领7天免费卡</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, ref, toRefs, defineComponent, onBeforeMount } from "vue";
import { useRouter, useRoute } from "vue-router";
import passwordLogin from "@/components/login/passwordLogin.vue";
import shortMessageLogin from "@/components/login/shortMessageLogin.vue";
export default defineComponent({
  name: "login",
  components: {
    passwordLogin,
    shortMessageLogin,
  },
  setup() {
    const activeName = ref<string>("shortMessage");
    const isMobile = ref(true)
    onBeforeMount(()=>{
      if(navigator.userAgent.match(/mobile/i)){
        isMobile.value = false;
      }
      console.log(isMobile.value);
      
    })

    return {
      activeName,
      isMobile
    };
  },
});
</script>
<style lang="less">
.e-tabs {
  .el-tabs__nav-scroll {
    font-size: 14px;
  }
  .el-tabs__item {
    font-size: 18px !important;
    color: #999999 !important;
    font-weight: bold;
  }
  .el-tabs__item.is-active {
    background-color: #fff !important;
    color: #191c29 !important;
  }
  .el-tabs__active-bar {
    // position: relative;
    // top: 60px;
    background-color: #191c29;
  }
  .el-tabs__nav-wrap {
    height: 60px;
  }
  .el-tabs__nav {
    height: 60px;
    display: flex;
  }
}

.el-int {
  .el-input__inner {
    height: 40px;
    border: none;
    background: none !important;
  }
}
.code {
  .el-input__inner {
    background: #f0f0f0 !important;
  }
}
.checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ffca28;
  border-color: #ffca28;
}
.checkbox .el-checkbox__inner:hover {
  border-color: #ffca28;
}


@media only screen and (max-width: 850px){
  .e-tabs{
    .el-tabs__item{
      font-size: 16px !important;
    }
  }
}
</style>
<style lang="less" scoped>
@import url("@/assets/styles/common.less");
.login-index {
  .boxSize(100%,100%);
  .header_logo {
    width: 300px;
    padding-top: 20px;
    .Flex(flex-start,center);
    .font(#B0B1B5,16px);
  }
  .content {
    .boxSize(100%,460px);
    .Flex(center);
    .l-img {
      height: 100%;
      background: url('@/assets/images/register/left_bg.png');
      background-size: 100% 100%;
      padding: 30px;
      box-sizing: border-box;
      position: relative;
      width:45%;
      .p1 {
        font-size: 16px;
        color: #ffffff;
        line-height: 32px;
      }
      .line {
        width: 18px;
        height: 6px;
        background: #ffffff;
        margin-top: 12px;
      }
      .loginLogo {
        position: absolute;
        left: 30px;
        bottom: 40px;
      }
    }
    .title {
      .font(white,22px);
    }
    .main {
      .boxSize(55%,100%);
      box-sizing: border-box;
      position: relative;
      background-color: #fff;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      .title {
        .boxSize(124px,24px,24px);
        background-color: #fcf0f0;
        text-align: center;
        border-radius: 4px;
        .font(#DE3030,12px);
        .Position(absolute,none,28px,25px,none);
      }
    }
  }
}
@media only screen and (max-width: 850px){
  .login-index{
    width: 100%;
    background: white;
    overflow: hidden;
    // background-image: none;
    .header_logo{
      left: 20px;
      .el-image{
        height: 40px;
        width: 140px;
      }
    }
    .content{
      transform: none;
      width: calc(100% - 40px);
      position:static;
      padding: 20px;
      .l-img{
        display: none;
      }
      .main{
        width: 100%;
        padding: 0px;
        .title{
          top: 10px;
          width: 109px;
          height: 20px;
          line-height: 20px;
        }
      }
    }
  }
  
}
</style>